module.exports = __webpack_public_path__ + "img/seo_gsport_item02.5cbfa1e.webp";